export default "__VITE_ASSET__DHrVSCNu__"